import React from 'react'

import { useResponsive } from '@clickcease/cc-client-components-lib'
import { TopNav } from 'Components/Elements/TopNav/TopNav'
import { MobileMenuHeader } from 'Components/Elements/MobileMenuHeader/MobileMenuHeader'
import { MainMenu } from 'Features/mainMenu/MainMenu'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { MainWrapper as MainWrapperStyled } from '../../components/Layout/MainWrapper.styled'
import { VerticalScrollModifier } from 'Components/Layout/VerticalScrollModifier'
import { ProtectedRouteLogic } from './components/ProtectedRouteLogic'
import { useLocation } from 'react-router-dom'
import useMainWrapperStore from './stores/mainWrapper'

type MainWrapperProps = {
  children: React.ReactNode
}

export const MainWrapper = ({ children }: MainWrapperProps) => {
  const location = useLocation()
  const { isMobileMenuOpen } = useAppStore()
  const { isMobile } = useResponsive()
  const { isTopBannerVisible } = useMainWrapperStore()

  const shouldRenderMenu = () => !isMobile || (isMobileMenuOpen && isMobile)

  const renderHeader = () => (isMobile ? <MobileMenuHeader /> : <TopNav />)

  const isPagesWithoutVerticalScroll = ['/domain-management'].includes(location.pathname)
  return (
    <>
      <ProtectedRouteLogic />
      <MainWrapperStyled bannerShown={isTopBannerVisible}>
        {shouldRenderMenu() && <MainMenu />}
        <div className="container">
          {renderHeader()}
          {isPagesWithoutVerticalScroll ? (
            children
          ) : (
            <VerticalScrollModifier>{children}</VerticalScrollModifier>
          )}
        </div>
      </MainWrapperStyled>
    </>
  )
}
